import { Message } from './Message';
import { StreamingMessage } from './StreamingMessage';
import { ProfileProgress } from './ProfileProgress';
import type { Message as MessageType, Artifact, ProfileProgress as ProfileProgressType } from '@/types';

interface MessageListProps {
  messages: MessageType[];
  isStreaming: boolean;
  streamingContent: string;
  streamingArtifacts: Artifact[];
  profilingProgress: ProfileProgressType | null;
  thinkingStatus?: string | null;
}

export function MessageList({
  messages,
  isStreaming,
  streamingContent,
  streamingArtifacts,
  profilingProgress,
  thinkingStatus,
}: MessageListProps) {
  return (
    <div className="mx-auto max-w-3xl px-4">
      {messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}

      {isStreaming && profilingProgress && !streamingContent && (
        <ProfileProgress progress={profilingProgress} />
      )}

      {isStreaming && (streamingContent || !profilingProgress) && (
        <StreamingMessage
          content={streamingContent}
          artifacts={streamingArtifacts}
          thinkingStatus={thinkingStatus}
        />
      )}

      {messages.length === 0 && !isStreaming && (
        <div className="p-8 text-center text-muted-foreground">
          Start a conversation with ZAC
        </div>
      )}
    </div>
  );
}
